import { render, staticRenderFns } from "./Tabframe.vue?vue&type=template&id=1bac538a&"
import script from "./Tabframe.vue?vue&type=script&lang=js&"
export * from "./Tabframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports